<template>
  <div class="ui bottom attached tab segment" data-tab="interaction">
    <h4 class="ui dividing header">{{ $t("current interaction") }}</h4>
    <h3 class="ui header" v-if="interaction && interaction.component">
      <div class="ui icon blue labeled button" @click="retry">
        <i class="history icon"></i> {{ $t("retry") }}
      </div>
      <div class="content">
        {{ interaction.component.name }}
        <div class="sub header">
          {{ interaction.component.$type }}
        </div>
      </div>
    </h3>
    <!-- <pre>{{ interaction }}</pre> -->
  </div>
</template>

<script>
import { local_api, error_toast, success_toast } from "@/utils";

export default {
  name: "NgineInstanceManagerModalInteraction",
  props: {
    interaction: Object,
  },
  data() {
    return {};
  },
  methods: {
    retry() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to retry this interaction?"),
        function() {
          local_api(vm, "post", "/ngine_core/instance/do-retry-interaction", {
            u: vm.interaction.interaction_id,
          })
            .then((r) => {
              success_toast(r);
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
};
</script>
